import React, { useReducer } from "react";
import plataformasReducer from "./plataformasReducer";
import plataformasContext from "./plataformasContext";

import {
    getAllPlataformas as getAllPlataformasAPI,
    addPlataforma as addPlataformaAPI,
    updatePlataforma as updatePlataformaAPI,
    deletePlataforma as deletePlataformaAPI,
    getPlataformaStats as getPlataformaStatsAPI
} from "../../api/plataforma";

import {
    OBTENER_PLATAFORMAS,
    AGREGAR_PLATAFORMA,
    ACTUALIZAR_PLATAFORMA,
    ELIMINAR_PLATAFORMA,
    PLATAFORMA_ERROR,
    OBTENER_PLATAFORMA_STATS
} from "./plataformasActions";

const PlataformasState = props => {

    const initialState = {
        plataformas: [],
        mensaje: null,
        stats: null
    };

    const [state, dispatch] = useReducer(plataformasReducer, initialState);

    const getAllPlataformas = async () => {
        try {
            const respuesta = await getAllPlataformasAPI();
            dispatch({
                type: OBTENER_PLATAFORMAS,
                payload: respuesta.data.data
            });
        } catch (error) {
            console.log(error);
            dispatch({
                type: PLATAFORMA_ERROR,
                payload: error.response?.data?.message || error.message
            });
        }
    };

    const addPlataforma = async (plataforma) => {
        try {
            const respuesta = await addPlataformaAPI(plataforma);
            dispatch({
                type: AGREGAR_PLATAFORMA,
                payload: respuesta.data.data
            });
            return respuesta.data.data;
        } catch (error) {
            console.log(error);
            dispatch({
                type: PLATAFORMA_ERROR,
                payload: error.response?.data?.message || error.message
            });
            throw error;
        }
    };

    const updatePlataforma = async (plataforma) => {
        try {
            const respuesta = await updatePlataformaAPI(plataforma);
            dispatch({
                type: ACTUALIZAR_PLATAFORMA,
                payload: respuesta.data.data
            });
            return respuesta.data.data;
        } catch (error) {
            console.log(error);
            dispatch({
                type: PLATAFORMA_ERROR,
                payload: error.response?.data?.message || error.message
            });
            throw error;
        }
    };

    const deletePlataforma = async (plataforma) => {
        try {
            await deletePlataformaAPI(plataforma);
            dispatch({
                type: ELIMINAR_PLATAFORMA,
                payload: plataforma._id
            });
        } catch (error) {
            console.log(error);
            dispatch({
                type: PLATAFORMA_ERROR,
                payload: error.response?.data?.message || error.message
            });
            throw error;
        }
    };

    const getPlataformaStats = async () => {
        try {
            const respuesta = await getPlataformaStatsAPI();
            dispatch({
                type: OBTENER_PLATAFORMA_STATS,
                payload: respuesta.data.data
            });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <plataformasContext.Provider
            value={{
                plataformas: state.plataformas,
                mensaje: state.mensaje,
                stats: state.stats,
                getAllPlataformas,
                addPlataforma,
                updatePlataforma,
                deletePlataforma,
                getPlataformaStats
            }}
        >
            {props.children}
        </plataformasContext.Provider>
    );
};

export default PlataformasState;
